import React from "react";
import Navbar from "../../Navbar";
import MastersNav from "./MastersNav";
import "./MasterCommon.css";

export default function MasterShell({
  children,
  pageClassName = "",
  showMastersNav = false,
}) {
  return (
    <>
      <Navbar />
      <div className={`masters-shell ${pageClassName}`.trim()}>
        <div className="masters-shell__container">
          <div className="masters-shell__panel">
            {showMastersNav ? <MastersNav /> : null}
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
